import React from 'react';
import { motion } from 'framer-motion';
import { Hand } from 'lucide-react';
const situations = ['La lectura termina en llanto — o en silencio tenso que es casi peor que el llanto.', 'Dice "soy malo para leer" — y vos no sabés cómo revertir esa creencia sin mentirle.', 'Lo entiende un día y al siguiente lo olvidó — como si nunca hubiera practicado.'];
export function ProblemSection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-238">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-239">
        <div className="text-center mb-8" data-id="element-240">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-navy" data-id="element-241">
            ¿Hasta cuándo la lectura va a seguir siendo una batalla en tu casa?
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-242">
            Querés ayudarlo, pero cuando se traba no sabés qué hacer. Lo
            corregís, repite la palabra y al rato la olvida. No es falta de amor
            ni de esfuerzo: es falta de un sistema.
          </p>
        </div>

        <div className="bg-slate-50 rounded-3xl p-8 border border-slate-200 mb-8" data-id="element-243">
          <div className="space-y-4" data-id="element-244">
            {situations.map((text, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-slate-100" data-id="element-245">
                <Hand className="w-5 h-5 text-amber-500 mr-4 flex-shrink-0 mt-1" data-id="element-246" />
                <p className="text-slate-700 font-medium" data-id="element-247">{text}</p>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-248">
          <p className="text-xl font-bold text-navy italic" data-id="element-249">
            ¿Y si la próxima semana la lectura dejara de ser una batalla en
            casa?
          </p>
        </div>
      </div>
    </section>;
}